import { render, staticRenderFns } from "./f-media.vue?vue&type=template&id=50a4cb00&lang=pug&"
import script from "./f-media.vue?vue&type=script&lang=js&"
export * from "./f-media.vue?vue&type=script&lang=js&"
import style0 from "./f-media.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a4cb00')) {
      api.createRecord('50a4cb00', component.options)
    } else {
      api.reload('50a4cb00', component.options)
    }
    module.hot.accept("./f-media.vue?vue&type=template&id=50a4cb00&lang=pug&", function () {
      api.rerender('50a4cb00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-media.vue"
export default component.exports